import React, { ReactElement, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Applications, LicenceDetailsProps } from './LicenseDetails.types'
import { getLicenseDetails } from '../../license/License.actions'
import { IAppState } from 'core/store/store'
import { Button, ButtonType, CardContainer, Spinner } from '@digicert/dcone-common-ui'
import { formatDate, translate } from 'shared/helpers/utils'
import styles from './LicenseDetails.module.scss'
import { Translate } from 'react-localize-redux'
import { Link } from 'react-router-dom'
import { RouterConfig } from 'core/utils/constants'
import { ApplicationPermissionMap } from 'core/selectors/Profile.selectors'
import { LicenseCard } from '../licenseCard/LicenseCard'

const LicenseDetails = (props: LicenceDetailsProps) => {
  const { getLicenseDetails, profile } = props
  const [licenseApplications, setLicenseApplications] = useState<Applications[]>([])
  const [organization, setOrganization] = useState('')
  const [id, setId] = useState('')
  const [endDate, setEndDate] = useState('')
  const [lastUpdated, setLastUpdated] = useState('')
  const [dateLicenseUsed, setDateLicenseUsed] = useState('')
  const [version, setVersion] = useState('')
  const [canUploadLicense, setCanUploadLicense] = useState(false)

  useEffect(() => {
    getLicenseDetails().then((response: any) => {
      if (response) {
        setLicenseApplications(response.applications)
        setOrganization(response.organization)
        setId(response.id)
        setEndDate(response.expires_at)
        setLastUpdated(response.last_updated)
        setDateLicenseUsed(response.license_used)
        setVersion(response.version)
      }
    })
    if (profile) {
      Object.keys(profile.permissions).forEach(key => {
        if (profile.permissions[key].name === ApplicationPermissionMap.canManageAMLicense) {
          setCanUploadLicense(true)
        }
      })  
    }
  }, [getLicenseDetails])

  const renderSpinner = (): ReactElement => {
    return (
      <div className='spin-wrap'>
        <Spinner />
      </div>
    )
  }

  const renderLicenseInformation = (): ReactElement => {
    return (
      <div className={styles.container}>
        <div>
          <p className={styles.name}><Translate id='licenseDetails.dateLicenseUsed' /></p>
          <p className={styles.value}>{formatDate(dateLicenseUsed, profile?.date_format as string)}</p>
        </div>
        <div>
          <p className={styles.name}><Translate id='licenseDetails.lastUpdated' /></p>
          <p className={styles.value}>{formatDate(lastUpdated, profile?.date_format as string)}</p>
        </div>
        <div>
          <p className={styles.name}><Translate id='licenseDetails.endDate' /></p>
          <p className={styles.value}>{formatDate(endDate, profile?.date_format as string)}</p>
        </div>
        <div>
          <p className={styles.name}><Translate id='licenseDetails.organization' /></p>
          <p className={styles.value}>{organization}</p>
        </div>
        <div>
          <p className={styles.name}><Translate id='licenseDetails.id' /></p>
          <p className={styles.value}>{id}</p>
        </div>
      </div>)
  }

  const renderLicenseDetails = (): ReactElement => {
    let data
    if (licenseApplications.length > 0) {
        if (licenseApplications.filter(app => app.features !== undefined).length > 0) {
          return (
            <div>
              <h4 className={styles.subTitle}><Translate id='licenseDetails.applications' /></h4>
              <CardContainer>
                {
                  licenseApplications.map((app) => {
                    const renderApplicationName = ():any => {
                      switch (app.app_code) {
                        case app.app_code: return translate('dashboardLicense.applications.'+app.app_code) as string;
                      }
                    }
                    data = app.features ? app.features.map(feat => {
                      if (feat.attributes) {
                        return {
                          id: feat.name,
                          licenseType: translate('dashboardLicense.features.' + feat.name) as string,
                          quantity: feat.attributes.limit
                        }
                      }
                    }) : undefined
                    if (data) {
                      Object.keys(data).forEach(key => data[key] === undefined && delete data[key])
                    }

                    return (
                      <LicenseCard key={app.id} data={data} title={renderApplicationName()}/>
                    )
                  })
                }
              </CardContainer>
            </div>
          )
       }
       return (<></>)
    } else {
      return (renderSpinner())
    }
  }

  const renderUploadLicenseBtn = (): ReactElement => {
    return (
      <Link to={RouterConfig.platformSettings.updateLicense}>
        <Button
          buttonType={ButtonType.SECONDARY} >
          <Translate id='common.form.buttons.updateLicense' />
        </Button>
      </Link>
    )
  }

  return (
    <>
      {canUploadLicense && renderUploadLicenseBtn()}
      {renderLicenseInformation()}
      {version !== '1.0' && renderLicenseDetails()}
    </>)
}

export default connect((state: IAppState) => ({
  profile: state.profile.data
}),
  {
    getLicenseDetails
  }
)(LicenseDetails)

